import { HomeRoutes, MediaTypesRoutes, MemberMediaTypesRoutes, SiteEnum, } from './enums';
export const VideoOptions = {
    STOCK_FOOTAGE: 'stock-footage',
    BACKGROUNDS: 'animated-backgrounds',
    TEMPLATES: 'Templates',
};
export const TemplateOptions = {
    PREMIERE_PRO: 'premiere-pro-templates',
    AFTER_EFFECTS: 'after-effects-templates',
    DAVINCI_RESOLVE: 'davinci-resolve-templates',
    APPLE_MOTION: 'apple-motion-templates',
};
export const AudioOptions = {
    MUSIC: 'royalty-free-music',
    EFFECTS: 'sound-effects',
};
export const COLLECTIONS = 'Collections';
export const TOP_LEVEL_OPTIONS = [
    {
        label: 'Video Home',
        site: SiteEnum.Videoblocks,
        url: HomeRoutes.Videoblocks,
        options: [
            {
                label: VideoOptions.STOCK_FOOTAGE,
                url: MediaTypesRoutes.VideoFootage,
            },
            {
                label: VideoOptions.BACKGROUNDS,
                url: MediaTypesRoutes.VideoMotionBackgrounds,
            },
            {
                label: VideoOptions.TEMPLATES,
                url: MediaTypesRoutes.VideoTemplates,
            },
        ],
    },
    {
        label: 'Audio Home',
        site: SiteEnum.Audioblocks,
        url: HomeRoutes.Audioblocks,
        options: [
            { label: AudioOptions.MUSIC, url: MediaTypesRoutes.AudioMusic },
            { label: AudioOptions.EFFECTS, url: MediaTypesRoutes.AudioSfx },
        ],
    },
    {
        label: 'Images Home',
        site: SiteEnum.Graphicstock,
        url: HomeRoutes.Graphicstock,
    },
    {
        label: COLLECTIONS,
    },
];
export const getTopLevelOptions = (isLoggedIn) => {
    return [
        {
            label: 'Video',
            site: SiteEnum.Videoblocks,
            url: HomeRoutes.Videoblocks,
            options: [
                {
                    label: VideoOptions.STOCK_FOOTAGE,
                    url: isLoggedIn
                        ? MemberMediaTypesRoutes.VideoFootage
                        : MediaTypesRoutes.VideoFootage,
                },
                {
                    label: VideoOptions.BACKGROUNDS,
                    url: isLoggedIn
                        ? MemberMediaTypesRoutes.VideoMotionBackgrounds
                        : MediaTypesRoutes.VideoMotionBackgrounds,
                },
            ],
        },
        {
            label: 'Templates',
            site: SiteEnum.Videoblocks,
            url: isLoggedIn
                ? MemberMediaTypesRoutes.Templates
                : MediaTypesRoutes.VideoTemplates,
            options: [
                {
                    label: TemplateOptions.AFTER_EFFECTS,
                    url: isLoggedIn
                        ? MemberMediaTypesRoutes.TemplateAfterEffects
                        : MediaTypesRoutes.TemplateAfterEffects,
                },
                {
                    label: TemplateOptions.PREMIERE_PRO,
                    url: isLoggedIn
                        ? MemberMediaTypesRoutes.TemplatePremierePro
                        : MediaTypesRoutes.TemplatePremierePro,
                },
                {
                    label: TemplateOptions.DAVINCI_RESOLVE,
                    url: isLoggedIn
                        ? MemberMediaTypesRoutes.TemplateDaVinciResolve
                        : MediaTypesRoutes.TemplateDaVinciResolve,
                },
                {
                    label: TemplateOptions.APPLE_MOTION,
                    url: isLoggedIn
                        ? MemberMediaTypesRoutes.TemplateAppleMotion
                        : MediaTypesRoutes.TemplateAppleMotion,
                },
            ],
        },
        {
            label: 'Audio',
            site: SiteEnum.Audioblocks,
            url: HomeRoutes.Audioblocks,
            options: [
                {
                    label: AudioOptions.MUSIC,
                    url: isLoggedIn
                        ? MemberMediaTypesRoutes.AudioMusic
                        : MediaTypesRoutes.AudioMusic,
                },
                {
                    label: AudioOptions.EFFECTS,
                    url: isLoggedIn
                        ? MemberMediaTypesRoutes.AudioSfx
                        : MediaTypesRoutes.AudioSfx,
                },
            ],
        },
        {
            label: 'Images',
            site: SiteEnum.Graphicstock,
            url: HomeRoutes.Graphicstock,
        },
        {
            label: COLLECTIONS,
        },
    ];
};
export const searchOrigins = {
    FILTERS: 'filters',
    SEARCH_BAR: 'search_bar',
    SORT_BY: 'sort_by',
    TYPE_AHEAD: 'type_ahead',
    STOCK_ITEM_CARD: 'stock_item_card',
    UNKNOWN: '(unknown)',
    HOME: 'home',
    TOP_NAV: 'top_nav',
    DETAILS_PAGE: 'details_page',
    RELATED_SEARCH: 'related-search',
    PAGINATION: 'pagination',
    ARTIST: 'artist',
    APPLIED_FILTERS: 'applied_filters',
    AUTOCORRECT: 'autocorrect',
};
export const imageMenu = [
    {
        url: '/images/vectors',
        title: 'Vectors',
    },
    {
        url: '/images/illustrations',
        title: 'Illustrations',
    },
    {
        url: '/images/photos',
        title: 'Photos',
    },
    {
        url: '/images/collections',
        title: 'Collections',
    },
];
